<template>
  <div class="row breadcrumbs-top">
    <div class="col-12">
      <h2 class="content-header-title float-left mb-0">{{ name }}</h2>
      <div class="breadcrumb-wrapper">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" :class="breadcrumb.length - 1 == index? 'active':''" :key="index"
              v-for="(item,index) in breadcrumb"><a
              :href="(typeof(item.link) != 'undefined') ? item.link : 'javascript:void(0)' ">{{ item.name }}</a>
          </li>
          <!--      <li class="breadcrumb-item active"><a href="javascript:void(0)">Send Money</a></li>-->
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['name', 'breadcrumb'],

}
</script>

